import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Portada_Servicios = () => {
    const {sCell} = useResponsive()
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container  alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 10}} sx={{maxWidth: 1400, px: 3, pt:sCell? 4:8,}} >
                <Grid container  alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 12}} sx={{borderBottom: '1px solid #DFDFDF',  pb:12}} >
                    <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{color: '#223B59'}}>
                        <Grid container  justifyContent={{ xs: 'center', md: 'flex-start' }} size={{xs: 12, sm: 12, md: 12}}>
                            <Typography component={"h1"} variant={'h1'} sx={{textAlign: sCell? 'center': 'left', pr:sCell?0:8 }}>
                                Servicios de mantenimiento locativo, adecuaciones y SST en obras | Espacio Compacto
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container  justifyContent={{ xs: 'center', md: 'flex-start' }} size={{xs: 12, sm: 5, md: 5}}>
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:sCell?4:0, }}>
                            <Typography component={'p'} variant={'body1'} sx={{textAlign: sCell? 'center': 'left' }}>
                                En el mercado abundan proyectos con SST solo en el papel, adecuaciones improvisadas, reprocesos por mala planificación y pausas por incumplimientos que terminan generando sobrecostos.                        </Typography>
                        </Grid>
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:4, }}>
                            <Typography component={'p'} variant={'body1'} sx={{textAlign: sCell? 'center': 'left' }}>
                                En espacio compacto arquitectura abordamos estos problemas desde un enfoque integral, donde la seguridad, el diseño y la ejecución trabajan de forma articulada.                        </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default Portada_Servicios